<div
  class="extra-info"
  *ngIf="selectedConversation"
>
  <div class="extra-info__container">
    @if (customer) {
      <div>
        <span class="title">Customer:</span> {{ customer?.name }}
      </div>
    }
    <p class="extra-info__item">
      <span class="title">SDR ID:</span> {{ sdrConversation?.sdrId }}
      <span class="title">SDR Name:</span> {{ sdrConversation?.sdrName }}
      @if (selectedConversation?.encryptedUrls.length > 0) {
        <a
          [href]="selectedConversation?.encryptedUrls[0]"
          target="_blank"
          class="extra-info__link"
        >
          <img
            src="/assets/images/linkedin_icon.png"
            class="linkedin-link-icon"
            height="16"
          />
        </a>
      }
    </p>
    @if (selectedConversation?.encryptedUrls?.length > 1) {
      @for (url of selectedConversation?.encryptedUrls; track url; let i = $index) {
        @if (i > 0) {
          <p
            class="extra-info__item"
          >
            <a
              [href]="url"
              target="_blank"
              >{{ url }}</a
            >
          </p>
        }
      }
    }
    <p class="extra-info__item">
      <span class="title">Conversation Id: </span>{{ selectedConversation?.conversationId }}
    </p>
  </div>
</div>
